import { RetryMessageDTO } from 'src/pages/VerificationPage/verificationModels';

export enum RetryModalActionType {
  Open = 'Open',
  Close = 'Close',
}

export interface RetryModalAction {
  type: RetryModalActionType;
  payload?: RetryMessageDTO;
}

export interface RetryModalState {
  isVisible: boolean;
  retryMessage?: RetryMessageDTO;
}

export const retryModalReducer = (
  state: RetryModalState,
  action: RetryModalAction
) => {
  const { type, payload } = action;
  switch (type) {
    case RetryModalActionType.Open:
      return {
        ...state,
        isVisible: true,
        retryMessage: payload,
      };
    case RetryModalActionType.Close:
      return {
        isVisible: false,
      };
    default:
      return state;
  }
};
